import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_139';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Otros activos', listHelp: ['157'] }
];

const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'valDeclarar', title: 'Valor a declarar'},
];


class Form1 {
  id: number;
  desc: string;
  valDeclarar:string;
  }
@Component({
  selector: 'app-patrimonio-inventario-modal',
  templateUrl: './patrimonio-inventario-modal.component.html',
  styleUrls: ['./patrimonio-inventario-modal.component.css'],
  providers: [
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioInventarioModalComponent extends HandlerModal implements OnInit {

  saveModel = new EventEmitter();
  public showSave:boolean;
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dialogRef: MatDialogRef<PatrimonioInventarioModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    public dNotificacionServicio: DNotificacionServicio
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
   /*  this.validateBtnRightActive();
    this.validateShowSave(); */
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valDeclarar="0";
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_216 == undefined){

      this.model.doc.cuerpo.cc_id_216 = []; 
      this.model.doc.cuerpo.cc_id_217 = [];
      this.model.doc.cuerpo.cs_id_158 = "0";
   
    }  
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_216.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_216[i].v;
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_217[i].v; 
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 158:
        this.operacionCs158();
        break;
    }
    if(soloEstaCasilla)return;


  }

  operacionCs158(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_158 = suma;  
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_216[this.modelForm.id].v=this.modelForm.desc.toString();
    this.model.doc.cuerpo.cc_id_217[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

  }
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_216.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_217.push({it: i, v:this.modelForm.valDeclarar.toString()});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_216.splice(index,1);
    this.model.doc.cuerpo.cc_id_217.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_216.length;i++){
      this.model.doc.cuerpo.cc_id_216[i].it=i+1;
      this.model.doc.cuerpo.cc_id_217[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valDeclarar==undefined ||  this.modelForm.valDeclarar=="0"  
       
  }

  public redondearFormData(){
    this.modelForm.valDeclarar=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
       // this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs158();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs158();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs158();
    this.dialogRef.close("");
  }
  public guardar(){
    this.model.doc.cuerpo.cc_id_216 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }

    this.operacionCs158();

    this.saveModel.emit(true);
    this.closeModal();
    
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-inventario-modal/patrimonio-inventario-modal.component.ts